import { postJson, getJson } from 'api/baseApi'

export const login = function ({ username, password }) {
  return postJson({ url: '/api/server/usersandgroups/authenticate', data: { Username: username, Password: password } })
}

export const revalidateCredentials = function ({ username, password }) {
  return postJson({ url: '/api/server/usersandgroups/revalidateCredentials', data: { Username: username, Password: password } })
}
export const logout = function () {
  return postJson({ url: '/api/server/usersandgroups/logout', data: '' })
}

export const getcurrentuserrights = function () {
  return getJson({ url: '/api/server/usersandgroups/getcurrentuserrights' })
}

export const getUsersAndGroups = function () {
  return getJson({ url: '/api/server/usersandgroups/entity/get/all' })
}

export const getUsers = function () {
  return getJson({ url: '/api/server/usersandgroups/entity/get/allusers' })
}

export const forgotpassword = function ({ username }) {
  return postJson({ url: '/api/server/usersandgroups/forgotpassword', data: { Username: username } })
}

export const hasvalidpasswordresetlink = function (passwordResetId) {
  return getJson({url: '/api/server/usersandgroups/hasvalidpasswordresetlink?PasswordResetId=' + passwordResetId})
}

export const resetpassword = function ({ password, id }) {
  return postJson({url: '/api/server/usersandgroups/resetpassword', data: { Password: password, PasswordResetId: id }})
}

export const getVisibleCompanies = function () {
  return getJson({url: '/api/server/usersandgroups/companies/visible'})
}

export const getExternalAccounts = function () {
  return getJson({ url: '/api/server/usersandgroups/getExternalAccounts' })
}

export const bindExternalName = function ({ identityProviderId, externalName }) {
  return postJson({ url: '/api/server/usersandgroups/bindExternalName', data: { IdentityProviderId: identityProviderId, ExternalName: externalName } })
}

export const unbindExternal = function (data) {
  return postJson({ url: '/api/server/usersandgroups/entity/unbind', data })
}

export const verifyMfa = function (data) {
  return postJson({ url: '/api/server/usersandgroups/verifymfa', data })
}

export const disableMfa = function () {
  return postJson({ url: '/api/server/usersandgroups/mfa/disable' })
}

export const getToken = function () {
  return getJson({ url: '/api/server/token/folderservice' })
}



// WEBPACK FOOTER //
// ./src/api/usersAndGroupsApi.js